import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Layout route for `/articles/$id`. It only renders an <Outlet/> so its children — the
 * detail (index) and the edit form — each take the full page (same pattern as
 * `surveys.$id`, which fixed the edit-child-not-rendering bug). Detail content
 * lives in `pd.$id.index.tsx`.
 */
export const Route = createFileRoute('/articles/$id')({
  component: () => <Outlet />,
});
